import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DialogData } from 'dg-emp-search-lib';
import { CaseView } from '../../models/caseview.model';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface Sender {
  docId: number;
  alphanum_Fileno: number;
  process: string;
  recipient: any;
  selectedRadio: any;
  showMsg: boolean;
  // target:string;
}

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'app-return-to-sender',
  templateUrl: './return-to-sender.component.html',
  styleUrls: ['./return-to-sender.component.scss'],
})
export class ReturnToSenderComponent implements OnInit {
  dataSource: Sender[];
  /*SENDER_DATA: Sender[] = [
    {alphanum_Fileno: 1, subject: 'notery1',recipient: ['Mr.Shah' , 'Mr. Patel']},
    {alphanum_Fileno: 2, subject: 'notery2',recipient: ['Mr.Desai', 'Mrs.Dsouza']}
    ]*/
  SENDER_DATA: Sender[] = [];
  singleData: Sender = {
    docId: null,
    alphanum_Fileno: null,
    process: null,
    recipient: [],
    selectedRadio: null,
    showMsg: false,
  };
  showTable = false;
  caseData: any = [];
  refIdList = '';
  selectedRadio: any;
  showMsg = false;

  docId: any;
  recep = {};
  displayedColumns: string[] = ['alphanum_Fileno', 'process', 'recipient'];
  selectedUnit: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReturnToSenderComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.caseData = this.data?.selectedData;

    //created to generate comma seperated caseIds
    for (const s of this.caseData) {
      this.refIdList += String(s.docId) + ',';
    }

    this.refIdList = this.refIdList.slice(0, -1);
    let params = new HttpParams();
    //this.docId =  this.caseData.docId
    params = params.append('appTypeId', this.caseData[0].appTypeId);
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '1');
    //params = params.append('recNo', this.refIdList);

    this.http
      .get('/workflow/hierarchy-details-revert', { params: params })
      .subscribe((res) => {
        const restemp: any = res;
        this.showTable = true;
        if (!restemp.data.length) {
          this.singleData.recipient.push('No person is mapped below you');
          this.singleData.showMsg = true;
        } else {
          this.showMsg = false;
          for (const val of this.caseData) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH = s.fileHierarchyVOArr;
                if (!fileH) {
                  this.singleData.recipient.push(s.msg);
                  this.singleData.showMsg = true;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
              // else {
              //   this.singleData.recipient = 'No person is mapped above you';
              // }
            }
            this.SENDER_DATA.push(this.singleData);
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              recipient: [],
              selectedRadio: null,
              showMsg: false,
            };
          }
        }
        this.dataSource = this.SENDER_DATA;
      });
  }

  /*onClose(): void {
    this.dialogRef.close();
  }*/

  onSend(): void {
    let postData = {
      refId: [],
      toUnit: [],
      toOrderNo: [],
      roleId: [],
      toMpgType: [],
      applTypeId: this.caseData[0].appTypeId,
      actionSentDate: '03-Dec-2020',
      actionDlvrDate: '03-Dec-2020',
      movmentActionFlag: 4,
      fromGrpId: null,
      toGrpId: null,
      fromType: null,
      toType: null,
      toRoleId: null,
      delegationVO: null,
      fromGrpWS: null,
      groupLevel: null,
      groupUnitId: null,
      groupId: null,
      recall: null,
      papsFlag: false,
      line: null,
    };
    let flag = 0;
    for (const s of this.dataSource) {
      postData.refId.push(Number(s.docId));
      if (!s.selectedRadio) {
        flag++;
      } else {
        postData.toUnit.push(s.selectedRadio.unitId);
        postData.toOrderNo.push(s.selectedRadio?.toOrderNo);
        postData.toMpgType.push(s.selectedRadio?.mpgType);
        if (s.selectedRadio?.mpgType === 657) {
          postData.roleId.push(s.selectedRadio?.roleId);
        } else {
          postData.roleId.push(-1);
        }
      }
    }
    if (flag) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant('return_to_sender.please_select'),
      });
    } else {
      if (!this.data?.isFromCustomAction) {
        this.http.post('/workflow/workflow-operation', postData).subscribe(
          (res) => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.dialogRef.close(false);
          }
        );
      } else {
        this.dialogRef.close(postData);
      }
    }
  }
  handleChange(event: any, actionName: string): void {
    console.log('on radio change', event);
    event.source.value.actionType = actionName;
    this.selectedUnit = event.value;
  }

  isButtonDisable(): boolean {
    return !this.selectedUnit;
  }
}
